import global from '../global'

const loginUserAccount = global.serverUrl + '/backstage/auth/login/account'
export default {
  loginUserAccount
}



// WEBPACK FOOTER //
// ./src/config/api/auth.js